<div class="flex flex-row gap-4 items-center justify-between">
  @let analysisConfigurationId = this.analysisConfigurationId();

  <!-- left sided -->
  <div class="flex flex-row gap-4 items-center">
    <pm-analysis-configuration-picker />

    @if (analysisConfigurationId) {
      <pm-analysis-version-picker />
    }

    @if (createAnalysisAllowed()) {
      <!-- trigger -->
      <pm-button
        variant="outlined"
        [matMenuTriggerFor]="menu"
        [icon]="moreIcon"
      />

      <!-- menu -->
      <mat-menu #menu="matMenu">
        @if (analysisConfigurationId) {
          <!-- recalc version -->
          <button
            mat-menu-item
            (click)="this.handleCreateVersion(analysisConfigurationId)"
          >
            <div class="inline-flex items-center">
              <pm-icon [icon]="recalculateVersionIcon" />
              <span class="ml-4">{{ 'ANALYSIS.RECALCULATE' | translate }}</span>
            </div>
          </button>
        }

        <!-- delete version -->
        @let versionId = this.analysisVersionId();
        @if (versionId) {
          <button mat-menu-item (click)="this.handleDeleteVersion(versionId)">
            <div class="inline-flex items-center">
              <pm-icon [icon]="deleteIcon" />
              <span class="ml-4">
                {{ 'ANALYSIS.DELETE_VERSION' | translate }}
              </span>
            </div>
          </button>
        }

        <!-- create new configuration -->
        <button mat-menu-item (click)="this.handleCreateErrorConfiguration()">
          <div class="inline-flex items-center">
            <pm-icon [icon]="plusIcon" />
            <span class="ml-4">
              {{ 'ANALYSIS.CREATE_CONFIGURATION.TITLE' | translate }}
            </span>
          </div>
        </button>

        <!-- delete configuration -->
        @if (analysisConfigurationId) {
          <button
            mat-menu-item
            (click)="
              this.handleDeleteErrorConfiguration(analysisConfigurationId)
            "
          >
            <div class="inline-flex items-center">
              <pm-icon [icon]="deleteIcon" />
              <span class="ml-4">
                {{ 'ANALYSIS.DELETE_ERROR_CONFIGURATION' | translate }}
              </span>
            </div>
          </button>
        }
      </mat-menu>
    }
  </div>

  <!-- right sided -->
  <div class="flex flex-row gap-4 items-center">
    @if (analysisVersionId()) {
      <pm-button
        variant="primary"
        text="ANALYSIS.EXPORT.BUTTON"
        [icon]="downloadIcon"
        (click)="openExportDialog()"
      />
    }
  </div>
</div>
